// Server-side limits for the invoice mutations; client forms read these rather than a copy.
export const INVOICE_CONSTRAINTS = {
    invoice: { label: 'Invoice' },
    voidReason: { label: 'Void reason', max: 2000 },
};
//# sourceMappingURL=constraints.js.map